import { get, post } from '../http-calls';

export const postMappingCategory = async (data) => {
    let res = await post(`MappingCategory/MappingCategory_AddUpdate`, data, { useAuthToken: true });
    return res;
};

export const postNominalDepartmentCodes_UpdateDescription = async (data) => {
    let res = await post(`NominalDepartmentCodes/NominalDepartmentCodes_UpdateDescription`, data, { useAuthToken: true });
    return res;
};

export const postNominalDepartmentCodeGroups_UpdateDescription = async (data) => {
    let res = await post(`NominalDepartmentCodes/NominalDepartmentCodeGroups_UpdateDescription`, data, { useAuthToken: true });
    return res;
};
export const NominalExpenseCode_UpdateDescription = async (data) => {
    let res = await post(`NominalExpenseCodes/NominalExpenseCode_UpdateDescription`, data, { useAuthToken: true });
    return res;
};

export const NominalExpenseCodeGroups_UpdateDescription = async (data) => {
    let res = await post(`NominalExpenseCodes/NominalExpenseCodeGroups_UpdateDescription`, data, { useAuthToken: true });
    return res;
};

export const getMappingCategoryById = async (id) => {
    let res = await get(`MappingCategory/MappingCategory_GetDetails/${id}`, { useAuthToken: true });
    return res;
};

export const getMANominalAccountHistoryByAccount = async (AccountCode) => {
    let res = await get(`NominalCodes/MANominalAccountHistoryByAccount?AccountCode=${AccountCode || ''}`, { useAuthToken: true });
    return res;
};
export const getMA_GetNominalTransactionDropdowns = async () => {
    let res = await get(`NominalTransaction/MA_GetNominalTransactionDropdowns`, { useAuthToken: true });
    return res;
};

export const getMADashboardGetDetailsByID = async (MADashboardID) => {
    let res = await get(`MADashboard/MADashboardGetDetails?MADashboardID=${MADashboardID}`, { useAuthToken: true });
    return res;
};

export const postMADashboard_AddUpdate = async (data) => {
    let res = await post(`MADashboard/MADashboard_AddUpdate`, data, { useAuthToken: true });
    return res;
};

export const getMA_DAshboard_Dropdown = async () => {
    let res = await get(`MADashboard/MADAshboard_Dropdown`, { useAuthToken: true });
    return res;
};

export const postMADashboard_CopyDashboard = async (data) => {
    let res = await post(`MADashboard/MADashboard_CopyDashboard`, data, { useAuthToken: true });
    return res;
};

export const postMADashboard_SwapSequence = async (MADashboardID1, MADashboardID2) => {
    let res = await post(`MADashboard/MADashboard_SwapSequence?MADashboardID1=${MADashboardID1}&MADashboardID2=${MADashboardID2}`, {}, { useAuthToken: true });
    return res;
};

export const deleteDashboardNominalAccount = async (id) => {
    let res = await post(`MADashboard/MADashboard_Delete?Id=${id}`, {}, { useAuthToken: true });
    return res;
};
